
import { defineComponent } from 'vue';
import { _Util } from '@/MyUtil';
import _ from 'lodash';
import { _ServerApi } from '@/serverAPI';


export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
      "util": _Util.getInstance(),
      "isError": false,
      "guid": "",
      "email": "",
      "password": "",
      "password2": "",

    }
  },
  components: {

  },
  methods: {
    clickHome(e: MouseEvent) {
      this.$router.push("/");
    },
    async changePassword() {
      const util = this.util;

      if (!util.isPasswdString(this.password)) {
        util.alert({
          msg: "변경 할 비밀번호는 최소8자 영문 숫자 특수문자가 필요합니다.",
          title: "안내",
          vue_ele: this.$root,
        });
        return;
      }

      if (this.password != this.password2) {
        util.alert({
          msg: "비밀번호와 비밀번호 확인이 다릅니다.",
          title: "안내",
          vue_ele: this.$root,
        });
        return;
      }

      if(!confirm("비밀번호를 변경 하시겠습니까?")){
        return "";
      }
      //api/setPasswordChange
      const _api = _ServerApi.getInstance();
      const result = await _api.postJson("/api/setPasswordChange",{
        "email" : this.email,
        "password" : this.password,
        "guid" : this.guid,
      });
      
      if(result.isError){
        util.alert({
          msg: result.msg,
          title: "안내",
          vue_ele: this.$root,
        });
        return;
      }
      this.$router.replace("/ResetPasswordResult");
      return;
    },

  },
  computed :{
  },
  async mounted() {

    const guid = this.$route.params.guid;
    const util = this.util;

    util.setLoading({
      isLoading: true,
      vue_ele: this.$root,
    });
    var _api = _ServerApi.getInstance();
    var result = await _api.postJson("/api/getPasswrdReset", {
      "guid": guid,
    });
    if (result.isError) {
      this.isError = true;
      return;
    }
    const data = result.data;
    this.email = data.email;
    this.guid = data.guid;


    await util.waitTime(500);
    util.setLoading({
      isLoading: false,
      vue_ele: this.$root,
    });

    return;
  }

});
